import { useRoutes, useNavigate, useLocation } from 'react-router-dom';
import routes from './router';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import ThemeProvider from './theme/ThemeProvider';
import { CssBaseline } from '@mui/material';
import { isDesktop } from 'react-device-detect';
import NotAllowed from './content/NotAllowed';
import { useState, useCallback } from 'react';
import { useSessionManager } from './hook/useSessionManager';
import ASMDialogSessionExpired from './components/Dialog/ASMDialogSessionExpired';
import { useAppDispatch } from 'src/redux/hook';
import { CURRENT_LANG, CURRENT_USER } from './constants';
import { authActions } from './redux/actions';
import { authProvider } from './services/auth.provider';
import { AuthenticationState } from 'react-aad-msal';

const AppContent = () => {
  const content = useRoutes(routes);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [sessionExpiredOpen, setSessionExpiredOpen] = useState(false);
  const locationTmp = useLocation();
  const handleExpired = useCallback(() => {
    setSessionExpiredOpen((prev) => {
      if (prev) return prev;
      return true;
    });
  }, []);

  const handleReconnect = async () => {
    dispatch(authActions.logout());
    localStorage.removeItem(CURRENT_USER);
    localStorage.removeItem("sessionStart");
    localStorage.removeItem("lastActivityAt");
    localStorage.removeItem(CURRENT_LANG);
    setSessionExpiredOpen(false);
    navigate('/', { replace: true });
  };

  useSessionManager({
    onInactivityExpired: handleExpired,
    onSessionExpired: handleExpired,
    pathname: locationTmp.pathname
  });

  if (!isDesktop) return <NotAllowed />;

  return (
    <>
      {/* Overlay bloque les clics DERRIÈRE le dialog */}
      {sessionExpiredOpen && (
        <div style={{
          position: 'fixed', inset: 0,
          zIndex: 1200,        // ← en dessous du Dialog MUI (1300)
          backgroundColor: 'transparent',
          pointerEvents: 'all'
        }} />
      )}
      {content}
      <ASMDialogSessionExpired
        open={sessionExpiredOpen}
        onClose={handleReconnect}
      />
    </>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <AppContent />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
